import React, { Fragment, useState} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { saveCharacter } from '../../../actions/character';

import { builds } from '../../../resources/builds';

const BuildLevelUp = ({
    character: {
        character
    },
    saveCharacter,
    closeModal,
    switchFromBuildToRegularModal
}) => {

    const {
        level,
        build,
        baseHP,
        currentHP,
        STR,
        DEX,
        CON,
        INT,
        WIS,
        CHA,
        armorLevel,
        assaultWeaponLevel,
        astrobiologyLevel,
        athleticsLevel,
        athleticsExpertise,
        bladeLevel,
        bluntLevel,
        energyLevel,
        espionageLevel,
        explosivesLevel,
        fluidLevel,
        gravLevel,
        longRangeLevel,
        negotiationLevel,
        observationLevel,
        pistolLevel,
        psycheLevel,
        techLevel,
        unarmedLevel,
        vehiclesLevel,
        waveLevel
    } = character;

    const attrList = ['STR', 'DEX', 'CON', 'INT', 'WIS', 'CHA'];
    const attrIncList = [];

    const [selectedAttr, updateSelectedAttr] = useState(null);

    const curBuildInfo = builds.find(b => b.name === build);
    const curLvlInfo = curBuildInfo.levelBreakdown[level];

    const affectedSkills = curLvlInfo.skillIncs.filter(x => x.inc > 0);
    const affectedAttr = curLvlInfo.attrIncs.filter(x => x.inc > 0);

    const showAffectedSkills = () => {
        const afSkills = affectedSkills.map((s, index) => 
            <p key={index}>{s.skill + `: +` + s.inc}</p>
        )

        return afSkills;
    }

    console.log(affectedAttr);

    const confirmLevelUp = e => {

        //Handle HP changes
        var HPchange = 2;

        if(athleticsLevel >= 5) { HPchange = 4 } else
        if(athleticsLevel >= 35 && athleticsExpertise === 'Bodybuilder'){ HPchange = 6 }


        //Save everything
        saveCharacter({
            ...character,
            'level': level + 1,
            'currentHP': currentHP + HPchange,
            'baseHP': baseHP + HPchange,
            'STR': STR + curLvlInfo.attrIncs[0].inc,
            'DEX': DEX + curLvlInfo.attrIncs[1].inc,
            'CON': CON + curLvlInfo.attrIncs[2].inc,
            'INT': INT + curLvlInfo.attrIncs[3].inc,
            'WIS': WIS + curLvlInfo.attrIncs[4].inc,
            'CHA': CHA + curLvlInfo.attrIncs[5].inc,
            'armorLevel': armorLevel + curLvlInfo.skillIncs[0].inc,
            'assaultWeaponLevel': assaultWeaponLevel + curLvlInfo.skillIncs[1].inc,
            'astrobiologyLevel': astrobiologyLevel + curLvlInfo.skillIncs[2].inc,
            'athleticsLevel': athleticsLevel + curLvlInfo.skillIncs[3].inc,
            'bladeLevel': bladeLevel + curLvlInfo.skillIncs[4].inc,
            'bluntLevel': bluntLevel + curLvlInfo.skillIncs[5].inc,
            'energyLevel': energyLevel + curLvlInfo.skillIncs[6].inc,
            'espionageLevel': espionageLevel + curLvlInfo.skillIncs[7].inc,
            'explosivesLevel': explosivesLevel + curLvlInfo.skillIncs[8].inc,
            'fluidLevel': fluidLevel + curLvlInfo.skillIncs[9].inc,
            'gravLevel':gravLevel + curLvlInfo.skillIncs[10].inc,
            'longRangeLevel': longRangeLevel + curLvlInfo.skillIncs[11].inc,
            'negotiationLevel': negotiationLevel + curLvlInfo.skillIncs[12].inc,
            'observationLevel': observationLevel + curLvlInfo.skillIncs[13].inc,
            'pistolLevel': pistolLevel + curLvlInfo.skillIncs[14].inc,
            'psycheLevel': psycheLevel + curLvlInfo.skillIncs[15].inc,
            'techLevel': techLevel + curLvlInfo.skillIncs[16].inc,
            'unarmedLevel': unarmedLevel + curLvlInfo.skillIncs[17].inc,
            'vehiclesLevel': vehiclesLevel + curLvlInfo.skillIncs[18].inc,
            'waveLevel': waveLevel + curLvlInfo.skillIncs[19].inc
        });

        closeModal();
    }

    return (
        <Fragment>
            <div className="levelUpWrapper">
                <div className='closeLvlUpModal' onClick={e => closeModal()(e)}>X</div>
                <h1>Level Up</h1>
                <div className="levelUpItem">
                    You have a build active, so we'll handle this level up for you. Review the following information and confirm!
                </div>
                <h2 className="text-blue">Skill Increases</h2>
                <div className="levelUpItem">
                    <div className="buildSkillIncList">{showAffectedSkills()}</div>
                </div>
                <h2 className="text-blue">Attribute Increases</h2>
                <div className="levelUpItem">
                    <p>{affectedAttr.length > 0 ? affectedAttr[0].attr + `: +` + affectedAttr[0].inc : "None"}</p>
                </div>
                <div className="buildLvlUpButs">
                    <div class="levelUpConfirm" onClick={e => confirmLevelUp(e)}>Confirm?</div>
                    <div class="levelUpCancel" onClick={e => switchFromBuildToRegularModal()(e)}>I'll Do It Myself</div>
                </div>
            </div>
            
        </Fragment>
    )
}

BuildLevelUp.propTypes = {
    character: PropTypes.object.isRequired,
    saveCharacter: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    switchFromBuildToRegularModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    character: state.character
});

export default connect(mapStateToProps, {saveCharacter})(BuildLevelUp);